<template>
  <p>Transaccion</p>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
